export interface ICountryPermissions {
  id: string
  country: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

export interface IUserTokens {
  id: string
  userId: string
  tokenType: 'ai_translation' | 'ai_generation' 
  currentUsage: number | null
  maxLimit: number
  resetDate: string
  createdAt: string
  updatedAt: string
}

export interface IUserInfo {
  accessToken: string
  id: string
  email: string
  firstName: string
  lastName: string
  fullName: string
  createdAt: string
  defaultCountry: string
  countryPermissions: ICountryPermissions[]
  cookiesFlag: boolean | undefined
  privacyPolicyFlag: boolean | undefined
  newsletterFlag: boolean | undefined
  tokens?: IUserTokens[]
}

export const LoadingStatus = {
  initial: 'initial',
  loading: 'loading',
  loaded: 'loaded',
  failed: 'failed'
} as const

type ValueOf<T> = T[keyof T]
export type TLoadingStatus = ValueOf<typeof LoadingStatus>
